export default __webpack_public_path__ + "static/media/farmlands_growing_c.3c7d2529.mp4";